import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription, interval } from 'rxjs';
import { ApiService } from '../services/contratos/contratos.service';
import { AppModule } from '../app.module';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CarregaService } from '../services/carrega_file/carrega.service';
import moment from 'moment';
import { format } from 'date-fns';
import { ChartData, ChartOptions, Chart } from 'chart.js';
import * as Highcharts from 'highcharts';

@Component({
    selector: 'app-ocupacao-trucks',
    templateUrl: './ocupacao-trucks.component.html',
    styleUrls: ['./ocupacao-trucks.component.css'],
    standalone: false
})
export class OcupacaoTrucksComponent implements OnInit, OnDestroy {
  // @ViewChild('meuCanvas', { static: true })
  @ViewChild('geral') geral!: ElementRef<HTMLCanvasElement>;
  @ViewChild('placas') placas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('datas') datas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('dateInput') dateInput: any;
  @ViewChild('dateInput2') dateInput2: any;
  chartGeral: Chart | null = null;
  chartByDate: Chart | null = null;
  chartByPlate: Chart | null = null;
  // elemento!: ElementRef;

  subscription: Subscription | undefined;
  items: any[] = [];
  fornecedores: any[] = [];
  posicao: any[] = [];
  sortColumn: string = '';
  sortNumber: number = 0;
  sortDirection: number = 1;
  dataLoaded = true;
  filtroDataInicio: Date = new Date();
  filtroDataTermino: Date = new Date();
  itemsFiltrados: any[] = [];
  searchText: string = '';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlSalva: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  query2: string = 'veiculos_lab_Karrara'
  data: any;
  DataAtual: Date = new Date();
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: ''
  };
  dialogOpen!: boolean;
  dialogAddViagem!: boolean;
  isLoading: boolean = true;
  posicaoCarros!: any[];
  veiculosLab: any;
  referenceDate!: string;
  cubageValues!: any[];
  weightValues!: any[];
  // Inicializa `startDate` para o primeiro dia do mês no formato 'yyyy-MM-dd'
  startDate: string = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    .toISOString()
    .split('T')[0];
  // Inicializa `endDate` para o dia atual no formato 'yyyy-MM-dd'
  endDate: string = new Date().toISOString().split('T')[0];
  cubageValuesTotal: number = 0;
  weightValuesTotal: number = 0;
  groupedByDate!: any[];
  groupedByPlate!: any[];
  numDays: number = 30;
  urlConsultaRangeDatas: string = 'https://5eqqes9yi5.execute-api.sa-east-1.amazonaws.com/v1';
  filterColumn: string = 'date';

  constructor(private dynamoDBService: ApiService, public dialog: MatDialog, private http: HttpClient, private carregaService: CarregaService) {
  }

  async ngOnInit() {
    await this.update();
  }

  convertDate(item: any) {
    const dateStr = item.date.split('T')[0]; // Garante que pega só a data
    // return `${item.Plate}\n${dateStr.split('-').reverse().join('/')}` // Formato para 'dd/mm/yyyy'
    return dateStr.split('-').reverse().join('/') // Formato para 'dd/mm/yyyy'
  }

  async atualizaGrafico() {
    if (this.chartGeral) {
      this.chartGeral.destroy();
    }
    if (this.chartByDate) {
      this.chartByDate.destroy();
    }
    if (this.chartByPlate) {
      this.chartByPlate.destroy();
    }
    // console.log(this.items)
    this.items = await this.items.sort((a, b) => {
      // const plateComparison = a.Plate.localeCompare(b.Plate);
      // if (plateComparison !== 0) {
      //   // Se as placas são diferentes, use a comparação delas
      //   return plateComparison;
      // } else {
      // Se as placas são iguais, ordena pela data
      return new Date(a.date).getTime() - new Date(b.date).getTime();
      // }
    });
    this.cubageValues = this.items.map(item => item.cubage);
    // console.log(this.cubageValues)
    this.weightValues = this.items.map(item => item.weightLoaded);
    this.chartGeral = await new Chart(this.geral.nativeElement, {
      // type: 'doughnut',
      type: 'bar',
      data: {
        labels: await this.items.map(item => {
          // Extrai a data original no formato 'yyyy-mm-dd' sem ajuste de fuso horário
      const data = this.convertDate(item)
      return `${item.Plate}\n${data}`
          // const dateStr = item.date.split('T')[0]; // Garante que pega só a data
          // return `${item.Plate}\n${dateStr.split('-').reverse().join('/')}` // Formato para 'dd/mm/yyyy'
        }),
        // labels: this.items.map(item => `${item.Plate}\n${new Date(item.date).toLocaleDateString('pt-BR')}`), // Combina a placa e a data formatada
        // labels: this.items.map(item => item.Plate), // Combina a placa e a data formatada
        datasets: [
          {
            label: 'Cubage',
            data: this.cubageValues, // Valores de cubage para cada item
            backgroundColor: '#4CAF50', // Cor de preenchimento
            borderColor: '#004511' // Cor da borda
          },
          {
            label: 'Weight Loaded',
            data: this.weightValues, // Valores de weightLoaded para cada item
            backgroundColor: '#FF5722', // Cor de preenchimento
            borderColor: '#125722' // Cor da borda
          }
        ]
      },
      options: {
        // indexAxis: 'y', // Define o gráfico como barras horizontais
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              color: '#FFFFFF' // Define a cor da fonte para os rótulos do eixo x
            }
          },
          y: {
            ticks: {
              color: '#FFFFFF' // Define a cor da fonte para os rótulos do eixo y
            }
          }
        }
        // scales: {
        //   x: {
        //     beginAtZero: true // Começa o eixo X no zero
        //   }
        // }
      }
    });

    this.chartByPlate = await new Chart(this.placas.nativeElement, {
      type: 'bar',
      data: {
        labels: await this.groupedByPlate.map(group => group[0].Plate), // Usar a primeira placa de cada grupo como rótulo
        datasets: [
          {
            label: 'Cubage',
            data: this.groupedByPlate.map(group =>
              group.reduce((sum: any, item: { cubage: any; }) => sum + item.cubage, 0) / group.length // Soma dos valores de `cubage` para cada grupo
            ),
            backgroundColor: '#4CAF50',
            borderColor: '#004511'
          },
          {
            label: 'Weight Loaded',
            data: this.groupedByPlate.map(group =>
              group.reduce((sum: any, item: { weightLoaded: any; }) => sum + item.weightLoaded, 0) / group.length // Soma dos valores de `weightLoaded` para cada grupo
            ),
            backgroundColor: '#FF5722',
            borderColor: '#125722'
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              color: '#FFFFFF' // Define a cor da fonte para os rótulos do eixo x
            }
          },
          y: {
            ticks: {
              color: '#FFFFFF' // Define a cor da fonte para os rótulos do eixo y
            }
          }
        }
      }
    });

    // Primeiro, ordenamos `groupedByDate` pela data de cada grupo
    const groupedByDateSorted = await this.groupedByDate.sort((a, b) =>
      new Date(a[0].date).getTime() - new Date(b[0].date).getTime()
    );

    this.chartByDate = await new Chart(this.datas.nativeElement, {
      type: 'bar',
      data: {
        labels: await groupedByDateSorted.map(group =>
          this.convertDate(group[0])
          // new Date(group[0].date).toLocaleDateString('pt-BR') // Formata a data como dd/mm/yyyy
        ),
        datasets: [
          {
            label: 'Cubage',
            data: await groupedByDateSorted.map(group =>
              group.reduce((sum: any, item: { cubage: any; }) => 
                sum + item.cubage, 0) / group.length // Média dos valores de `cubage`
            ),
            backgroundColor: '#4CAF50', // Cor de preenchimento
            borderColor: '#004511' // Cor da borda
          },
          {
            label: 'Weight Loaded',
            data: await groupedByDateSorted.map(group =>
              group.reduce((sum: any, item: { weightLoaded: any; }) => sum + item.weightLoaded, 0) / group.length // Média dos valores de `weightLoaded`
            ),
            backgroundColor: '#FF5722', // Cor de preenchimento
            borderColor: '#125722' // Cor da borda
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              color: '#FFFFFF' // Define a cor da fonte para os rótulos do eixo x
            }
          },
          y: {
            ticks: {
              color: '#FFFFFF' // Define a cor da fonte para os rótulos do eixo y
            }
          }
        }
      }
    });
  }

  async update() {
    await this.getVeiculosLab();
    await this.getItemsFromDynamoDB();
    // await this.getPositionLotsFromDynamoDB();
    // await this.armazenarLatitudeEmItems();
    this.isLoading = false;
  }

  async clearFilter() {
    this.dateInput.nativeElement.value = '';
    this.dateInput2.nativeElement.value = '';
  }

  async applyDateFilter() {
    this.isLoading = true;
    await this.update();
  }

  async deleteItem(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamoDBService.deleteItem(ID, this.urlSalva, "cargasInterplantasJetta").subscribe(
        async response => {
          // setTimeout(() => {
          await this.ngOnInit();
          this.isLoading = false;
        },
        error => {
        }
      );
    }
  }

  isISODateValid(dateString: string) {
    // Tenta criar um objeto Date a partir da string
    const date = new Date(dateString);
    // Verifica se o objeto Date é um objeto de data válido e não é NaN
    return !isNaN(date.getTime());
  }

  cancel(): void {
    this.dialogOpen = false;
    this.dialogAddViagem = false;
  }

  editDialog(item: any): void {
    this.item = { ...item }
    item.dataJanela = item.Janela.slice(0, 10);
    item.horaJanela = item.Janela.slice(11, 16);
    this.item.dataJanela = item.dataJanela;
    this.item.horaJanela = item.horaJanela;
    this.dialogOpen = true;
  }

  async salvar(item: any): Promise<void> {
    this.isLoading = true;
    this.dialogOpen = false;
    const dataHoraString = `${item.dataJanela}T${item.horaJanela}:00.000Z`;
    const dataHoraString2 = `${item.dataJanela}T${item.horaJanela}:00`;
    // console.log(dataHoraString)
    const dataHora = new Date(dataHoraString2);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = [];
    body = [{
      ...item, // Mantém as chaves existentes
      "ID": item.ID,
      "plate": item.plate,
      "danificado": item.danificado,
      "Janela": dataHoraString,
      "jan1": dataHora.toISOString(),
      // Adicione outros campos conforme necessário
    }];
    // console.log(body)
    await this.dynamoDBService.salvar(body, "cargasInterplantasJetta", this.urlSalva).subscribe(async response => {
      // Atualiza o item no banco de dados com sucesso
      // await this.ngOnInit();
      console.log('Dados salvos com sucesso!')
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
      // Lidar com o erro ao atualizar o item no banco de dados
    });
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getItemsFromDynamoDB(): Promise<void> {
    // console.log(this.startDate)
    // console.log(this.endDate)
    let referenceDateStart: string;
    let referenceDateEnd: string;
    if (this.startDate !== undefined && this.endDate !== undefined && this.startDate !== "Invalid Date" && this.endDate !== "Invalid Date" &&
      this.startDate !== "" && this.endDate !== "") {
      const startDate = new Date(this.startDate + "T00:00:00");
      const endDate = new Date(this.endDate + "T23:59:00");
      referenceDateStart = this.convertTimestampToFormattedDate(startDate.getTime());
      referenceDateEnd = this.convertTimestampToFormattedDate(endDate.getTime());
      const diffInMs = endDate.getTime() - startDate.getTime();
      this.numDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      this.numDays = this.numDays > 0 ? this.numDays : this.numDays = 1;
    } else {
      referenceDateEnd = this.convertTimestampToFormattedDate(Date.now());
      const dataAtual = new Date();
      dataAtual.setHours(23, 59, 59, 999); // Define as horas, minutos, segundos e milissegundos
      const diasParaSubtrair = 30;
      const dataPassada = new Date(dataAtual.getTime() - diasParaSubtrair * 24 * 60 * 60 * 1000);
      dataPassada.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos
      referenceDateStart = this.convertTimestampToFormattedDate(dataPassada.getTime());
      this.numDays = 30;
    }
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsRangeData("cargasInterplantasJetta", this.urlConsultaRangeDatas, 'All', this.filterColumn, referenceDateStart, referenceDateEnd, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.items = items
            this.items.forEach(item => {
              // console.log(item.Plate)
              this.cubageValuesTotal += item.cubage;
              this.weightValuesTotal += item.weightLoaded;
            });
            this.groupedByPlate = Object.values(
              this.items.reduce((result, item) => {
                const plate = item.Plate;
                // Se não existir o grupo com a placa atual, inicializa como um array vazio
                if (!result[plate]) {
                  result[plate] = [];
                }
                // Adiciona o item ao grupo correspondente
                result[plate].push(item);
                return result;
              }, {} as Record<string, any[]>)
            );
            // console.log( this.groupedByPlate )
            this.groupedByDate = Object.values(
              this.items.reduce((result, item) => {
                const dateStr = item.date
                // Se não existir o grupo com a placa atual, inicializa como um array vazio
                if (!result[dateStr]) {
                  result[dateStr] = [];
                }
                // Adiciona o item ao grupo correspondente
                result[dateStr].push(item);
                return result;
              }, {} as Record<string, any[]>)
            );
            // this.cubageValues = this.items.map(item => item.cubage);
            // console.log(this.cubageValues)
            // this.weightValues = this.items.map(item => item.weightLoaded);
            await this.atualizaGrafico();

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getVeiculosLab(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query2, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLab = items
              .map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Filtra os itens com chave 'DataBordo' indefinida
            // console.log(this.veiculosLab)

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  ngOnDestroy() {
    // Garante que o gráfico seja destruído ao sair do componente
    if (this.chartGeral) {
      this.chartGeral.destroy();
    }
    if (this.chartByDate) {
      this.chartByDate.destroy();
    }
    if (this.chartByPlate) {
      this.chartByPlate.destroy();
    }
  }

}
